import { styled } from '@olxeu-jobs/ui';

export const Wrapper = styled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  aspectRatio: '2/1',
  backgroundColor: $theme.colors['background-brand-disabled'],
  overflow: 'hidden',
  borderTopLeftRadius: $theme.radii[4],
  borderTopRightRadius: $theme.radii[4],
}));

export const FallbackImg = styled('img', { width: '40%' });
